import React from 'react';

const ActionMessageComponent = ({
  made2PT,
  made1PT,
  made3PT,
  miss1PT,
  miss2PT,
  miss3PT,
  shortFieldSelections,
  shortSelections,
  assistSelections,
  teamAssistSections,
  reboundSelections,
  teamReboundSections,
  toActions,
  foulActions,
  turnoverSelections,
  foulActionsSelections,
}) => {
  const getPtValue = (...conditions) => {
    const index = conditions.findIndex(c => c === "active");
    return index >= 0 ? (3 - index).toString() : "";
  };

  const getMadePtString = () => {
    const pts = [];
    if (made2PT) pts.push('2');
    if (made1PT) pts.push('1');
    if (made3PT) pts.push('3');
    return pts.join('');
  };

  const messageRules = [
    {
      condition: [made2PT, made1PT, made3PT].some(c => c === "active"),
      message: `Select player for ${getPtValue(made3PT, made2PT, made1PT)}PT made`
    },
    {
      condition: [miss1PT, miss2PT, miss3PT].some(c => c === "active"),
      message: `Select player for ${getPtValue(miss3PT, miss2PT, miss1PT)}PT miss`
    },
    { condition: shortFieldSelections, message: "Click on the location of the Action" },
    {
      condition: shortSelections,
      message: `Choose Action Detail of ${getMadePtString()}PT Made`
    },
    { condition: assistSelections, message: "Select player for Assist" },
    { condition: !teamAssistSections, message: "No assist is selected" },
    {
      condition: reboundSelections,
      message: `Select player made the ${teamReboundSections}`
    },
    { condition: toActions === "active", message: "Select player for turnover" },
    { condition: foulActions === "active", message: "Select player who commits foul" },
    { condition: turnoverSelections, message: "Select the player for steal" },
    { condition: foulActionsSelections, message: "Select player who draws personal foul" },
  ];

  const defaultMessage = "Select action";
  const matchedRule = messageRules.find(({ condition }) => condition);
  const message = matchedRule ? matchedRule.message : defaultMessage;

  return (
    <div className="text-[10px] lg:text-lg font-semibold text-gray-700 flex-1 text-left">
      {message}
    </div>
  );
};

export default ActionMessageComponent;